import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LightboxesService } from '../components/lightboxes/lightboxes.service';
import { CorretorFacade } from '../facades/corretor.facade';

@Injectable()
export class Interceptor401 implements HttpInterceptor {
  constructor(
    private router: Router,
    private lightBoxesService: LightboxesService,
    private corretorFacade: CorretorFacade,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(() => {},
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              this.corretorFacade.logout();

              window.setTimeout(() => {
                this.lightBoxesService.open({
                    title: 'Acesso expirado',
                    text: 'Faça o login novamente.'
                  },
                  60_000
                );
              }, 600);

              return;
            }
          }
        }
      )
    );
  }
}
